import React from 'react';
import './style.css';
import routeImage from '../../assets/maps-petruskirche-zeitraum.jpeg';
import parkingImage from '../../assets/zeitraum-parking.jpeg';

export class Location extends React.Component {
    render() {
        return (
            <div id="location-screen">
                <div className="location-container">
                    <div className="location-header-container">
                        <div className="location-header-content">DIE LOCATION</div>
                    </div>
                    <div className="location-address-container">
                        <div className="location-content-container">
                            <div className="location-content">
                                DIE ANSCHLIESSENDE FEIER FINDET IM ZEIT.RAUM IN SCHORNDORF STATT
                            </div>
                        </div>
                        <div className="location-route-container">
                            <div className="location-image-container">
                                <img
                                    alt="Route zur Location"
                                    src={routeImage}
                                    className="route-image"
                                    onClick={() =>
                                        window
                                            .open(
                                                'https://www.google.de/maps/dir/Petruskirche+Obert%C3%BCrkheim,+Kirchsteige,+Stuttgart/Zeit.Raum+GmbH,+Weilerstra%C3%9Fe,+Schorndorf/@48.7930662,9.2978808,12z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x4799c4178ede4397:0xd9b31ffc3c483ab3!2m2!1d9.2689311!2d48.767765!1m5!1m1!1s0x4799ba094bb7047d:0x19136e3aebeabdd6!2m2!1d9.518988!2d48.805042!3e0?entry=ttu',
                                                '_blank'
                                            )
                                            ?.focus()
                                    }
                                />
                            </div>
                            <div className="location-address-content-container">
                                <div className="location-address">
                                    Zeit.Raum <br /> Weilerstrasse 6 <br /> 73614 Schorndorf
                                </div>
                            </div>
                        </div>
                        <div className="location-parking-container">
                            <div className="location-address-content-container">
                                <div className="location-content">
                                    GENÜGEND PARKPLÄTZE FINDET IHR 180m HINTER DEM ZEIT.RAUM AUF DER RECHTEN SEITE
                                </div>
                                <div className="location-image-container">
                                    <img alt="Route zur Location" src={parkingImage} className="parking-image" />
                                </div>

                                <div className="location-address-content-container"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
